import { render, staticRenderFns } from "./RightToBuyMortgage.vue?vue&type=template&id=50a3307d"
import script from "./RightToBuyMortgage.vue?vue&type=script&lang=js"
export * from "./RightToBuyMortgage.vue?vue&type=script&lang=js"
import style0 from "./RightToBuyMortgage.vue?vue&type=style&index=0&id=50a3307d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports